import { GovIcon } from '@gov-design-system-ce/react';
import { Button } from '@gov-nx/ui/web';

export const ContinueButton = ({
	mainKey,
	formId,
	ts,
}: {
	mainKey: string;
	formId: string;
	ts: (key: string) => string;
}) => (
	<Button
		form={formId}
		nativeType="submit"
		color="primary"
		aria-label={ts('datova-schranka.modal.' + mainKey + '.wcag.pokracovat')}
		type="solid"
		isExpandedMobile
		size="m"
		iconStart={
			<GovIcon
				name="datovka-fill"
				type="templates"
			/>
		}>
		{ts('datova-schranka.modal.' + mainKey + '.pokracovat')}
	</Button>
);
